module.exports = __webpack_public_path__ + "img/count_1.92a868d6.png";